import React from 'react';
import { TableHead } from './TableHead';
import { TableBody } from './TableBody';
import { ResponsiveTable } from "../../../layout/Table/ResponsiveTable";

function TableComponent(props) {
    return (
      <ResponsiveTable>
        <TableHead
          shouldRenderFields={ props.shouldRenderFields }
          applySort={ props.applySort } />
        <TableBody
          shouldRenderFields={ props.shouldRenderFields }
          emailCampaigns={ props.emailCampaigns }
          actionCallback={ props.actionCallback }
        />
      </ResponsiveTable>
    )
}

export { TableComponent };
